// extracted by mini-css-extract-plugin
export default {"Container":"_Container--Y1b6N","Collapsed":"_Collapsed--qyRaS"};